import { z } from 'zod';
/**
 * Bình luận trên issue — APM-ISC-a, docs/02-sprint-plan.md `APM-ISC-*`.
 *
 * Hai luồng trên một issue:
 *
 * - `public` — đội xử lý ↔ người gửi + người theo dõi, hai chiều.
 * - `internal` — chỉ người có `issue:handle`. Không bao giờ ra khỏi đội xử lý:
 *   repository tự bỏ luồng này khi người đọc không có quyền, không để tầng trên
 *   truyền cờ.
 *
 * **Chỉ ghi thêm** — không sửa, không xoá (người dùng chốt 2026-09-30).
 */
export const IssueCommentVisibility = z.enum(['public', 'internal']);
export const ISSUE_COMMENT_MAX_LENGTH = 5_000;
export const CreateIssueCommentInput = z.object({
    visibility: IssueCommentVisibility,
    // `.trim()` **trước** `.min(1)`: chuỗi toàn dấu cách không thành một lời rỗng.
    body: z.string().trim().min(1).max(ISSUE_COMMENT_MAX_LENGTH),
});
export const IssueComment = z.object({
    id: z.uuid(),
    visibility: IssueCommentVisibility,
    body: z.string(),
    /** Tác giả có `issue:handle` lúc viết. */
    fromTeam: z.boolean(),
    authorId: z.uuid(),
    /**
     * `null` khi người đọc không có `issue:handle` và lời là của đội — giao diện
     * ghi "Đội xử lý", cùng luật với `IssueTimelineEntry.actorName`.
     */
    authorName: z.string().nullable(),
    createdAt: z.string(),
});
export const IssueCommentList = z.object({
    items: z.array(IssueComment),
    /** Người đọc gửi được vào luồng công khai (đội xử lý, người gửi, người theo dõi; issue chưa đóng). */
    canPostPublic: z.boolean(),
    /** Người đọc có `issue:handle` — thấy và gửi được luồng nội bộ. */
    canPostInternal: z.boolean(),
});
//# sourceMappingURL=issue-comment.js.map